@if (!!title?.length) {
<atx-modal-header [showCloseBtn]="showCloseBtn" (dismiss)="modal.dismiss()">
  {{ title }}
</atx-modal-header>
}
<atx-modal-body>
  @switch (true) { @case (isTemplate(message)) {
  <ng-template [ngTemplateOutlet]="message"></ng-template>
  } @default {
  {{ message }}
  } }
</atx-modal-body>
@if (!hideFooter) {
<atx-modal-footer>
  @if(showCancelButton) {

  <button
    data-e2e="cancel-confirm-btn"
    class="btn btn-light mr-2"
    (click)="modal.dismiss()"
    i18n="UI|Confirmation modal cancel button@@confirmationModalCancelButton"
  >
    Cancel
  </button>
  }
  <button
    data-e2e="confirm-btn"
    class="btn btn-primary"
    (click)="modal.close()"
  >
    {{ confirmButtonLabel }}
  </button>
</atx-modal-footer>
}
